import React from "react";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { Custom } from "components";
import { useApp, useSession, useTheme } from "contexts";

// icons
import {
  DriveFileRenameOutlineRounded,
  MoreVertRounded,
} from "@mui/icons-material";
import { useNavigationAction } from "hooks";

type Props = {};

export const Navigation = (props: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const { t, theme, isAuthenticated, user, handleProfile, handleLogout } =
    useNavigationAction();

  const handleClick = (event: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Custom.IconButton
        onClick={handleClick}
        id="user-navigation"
        aria-label="navigation"
        aria-haspopup="true"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
      >
        <Custom.Avatar alt={user.name} src={user.id} />
      </Custom.IconButton>

      <Custom.Menu id="menu" anchorEl={anchorEl} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            handleClose();
            handleProfile();
          }}
        >
          <ListItemText>{t.action.view_profile}</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            handleLogout();
          }}
        >
          <ListItemText>{t.action.sign_out}</ListItemText>
        </MenuItem>
      </Custom.Menu>
    </>
  );
};
